import Repository from './Repository';

const resource = '/collections';
export default {
  get() {
    return Repository.get(`${resource}?p=y`);
  },
};
